import { getHighLevelStatus, HighLevelStatus } from '@/utils/highLevelStatus';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';
import React, { createContext, useContext, ReactNode } from 'react';

export type SalesStatusContextType = {
  salesStatusData?: WebappResponse['salesStatus'];
  displayStatus: HighLevelStatus;
};

const SalesStatusContext = createContext<SalesStatusContextType>({ displayStatus: HighLevelStatus.UNKNOWN });

type SalesStatusProviderProps = {
  children: ReactNode;
  salesStatusData?: WebappResponse['salesStatus'];
};

export const SalesStatusProvider: React.FC<SalesStatusProviderProps> = ({ children, salesStatusData }) => {
  return (
    <SalesStatusContext.Provider value={{ salesStatusData, displayStatus: getHighLevelStatus(salesStatusData) }}>
      {children}
    </SalesStatusContext.Provider>
  );
};

export const useSalesStatus = (): SalesStatusContextType => {
  const context = useContext(SalesStatusContext);
  if (context === undefined) {
    throw new Error('useSalesStatus must be used within a SalesStatusProvider');
  }
  return context;
};
